import { render, staticRenderFns } from "./PopUpForgot.vue?vue&type=template&id=9d9e9cf6&scoped=true"
import script from "./PopUpForgot.vue?vue&type=script&lang=js"
export * from "./PopUpForgot.vue?vue&type=script&lang=js"
import style0 from "./PopUpForgot.vue?vue&type=style&index=0&id=9d9e9cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9e9cf6",
  null
  
)

export default component.exports